



export function Tooltip({x, y, message, width, height, position, size, multiline} : {x: number, y: number, message: any, width?: number, height?: number, position?: 'right' | 'top', size?: 'xs' | 'sm' | 'md' | 'lg', multiline?: boolean}) {

    const pos = position? position : 'right'; 
    const siz = size ? size : 'md';
    const tooltipHeight = height? height: 60;
    const tooltipWidth = width? width: 300; 

    const computePosition = () => {
        const xTranslation = pos == 'right' ? x + 15: x - tooltipWidth / 2;
        const yTranslation = pos == 'right' ?  y - tooltipHeight / 2 : y - tooltipHeight - 10;
        return {xTranslation, yTranslation};
    }


    return (<g transform={`translate(${computePosition().xTranslation}, ${computePosition().yTranslation})`}>
        <rect
            className="stroke-zinc-300"
            width={tooltipWidth}
            height={tooltipHeight}
            strokeWidth={'0.5'}
            fill={'white'}
            rx={'10'}
            ry={'10'}
        />
                    {/* <path stroke="black" strokeWidth={'1'} d="M 50,5 95,97.5 5,97.5 z"/> */}
            
        <text className={`text-${siz}`} transform={`${!multiline ? `translate(${5}, ${tooltipHeight / 2 + 5})` : ''}`}>{message}</text>
    </g>)


}